(() => {
  if (customElements.get('promo-bar')) {
    return;
  }

  class PromoBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.initElements();
      this.initSlider();
    }

    initElements() {
      this.slider = null;
      this.options = {
        slidesPerView: 1,
        loop: true,
      };
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('promo-bar', PromoBar);
})();
